import { supabase } from '../lib/supabase';

/**
 * CRUD Supabase pour les conversations Pilot.
 * RLS appliquée côté serveur : user_id = auth.uid().
 */
export const pilotService = {

  /** Dernière conversation active (la plus récente). Retourne null si aucune. */
  async getActiveConversation() {
    const { data, error } = await supabase
      .from('pilot_conversations')
      .select('id, title, created_at, updated_at')
      .order('updated_at', { ascending: false })
      .limit(1)
      .maybeSingle();

    if (error) {
      console.error('[pilotService] getActiveConversation:', error.message);
      return null;
    }
    return data; // null si aucune conversation
  },

  /**
   * Crée une nouvelle conversation. user_id est envoyé explicitement : la
   * politique RLS exige user_id = auth.uid(), sans dépendre d'un DEFAULT.
   */
  async createConversation(title = null) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user?.id) throw new Error('No user');
    const { data, error } = await supabase
      .from('pilot_conversations')
      .insert({ title, user_id: user.id })
      .select('id, title, created_at, updated_at')
      .single();
    if (error) throw error;
    return data;
  },

  /** Charge tous les messages d'une conversation, triés chronologiquement. */
  async getMessages(conversationId) {
    const { data, error } = await supabase
      .from('pilot_messages')
      .select('id, role, content, project_id, project_name, tools_used, created_at')
      .eq('conversation_id', conversationId)
      .order('created_at', { ascending: true });
    if (error) throw error;
    return data || [];
  },

  /** Ajoute un message et met à jour updated_at de la conversation. */
  async addMessage(conversationId, { role, content, projectId, projectName, toolsUsed }) {
    const { data, error } = await supabase
      .from('pilot_messages')
      .insert({
        conversation_id: conversationId,
        role,
        content,
        project_id: projectId || null,
        project_name: projectName || null,
        tools_used: toolsUsed || [],
      })
      .select('id, role, content, project_id, project_name, tools_used, created_at')
      .single();
    if (error) throw error;

    // Touch updated_at de la conversation
    await supabase
      .from('pilot_conversations')
      .update({ updated_at: new Date().toISOString() })
      .eq('id', conversationId);

    return data;
  },

  /** Met à jour le titre d'une conversation. */
  async updateConversationTitle(conversationId, title) {
    const { error } = await supabase
      .from('pilot_conversations')
      .update({ title })
      .eq('id', conversationId);
    if (error) console.error('[pilotService] updateTitle:', error.message);
  },
};

export default pilotService;
